import { withDevTools } from '../../utils/with-dev-tools';
import { wrapServiceWithResult } from '../../utils/wrap-service-with-result';
const getMemberFolloApi = async () => import(/* webpackChunkName: "members-v3-follow" */ '@wix/ambassador-members-v3-follow/http');
export function createMembersService({ httpClient, errorHandler, getDevState, onError, }) {
    const service = (() => {
        const api = {
            followMember: followMember(httpClient, errorHandler),
            unfollowMember: unfollowMember(httpClient, errorHandler),
        };
        return withDevTools(api, getDevState);
    })();
    return wrapServiceWithResult(service, {
        errorEffect: onError,
    });
}
const followMember = (httpClient, errorHandler) => async (payload) => {
    const { withErrorHandler, getResolvedError } = errorHandler;
    try {
        const membersFolowApi = await getMemberFolloApi();
        await withErrorHandler(() => httpClient.request(membersFolowApi.followMember(payload)), {
            errorCodesMap: {},
        });
    }
    catch (error) {
        getResolvedError(error);
        throw error;
    }
};
const unfollowMember = (httpClient, errorHandler) => async (payload) => {
    const { withErrorHandler, getResolvedError } = errorHandler;
    try {
        const membersFolowApi = await getMemberFolloApi();
        await withErrorHandler(() => httpClient.request(membersFolowApi.unfollowMember(payload)), {
            errorCodesMap: {},
        });
    }
    catch (error) {
        getResolvedError(error);
        throw error;
    }
};
//# sourceMappingURL=create-members-service.js.map